export function getReferenceRoomUrl(): string {
  // CloudFront の並行稼働中の、社内確認用の otameshi / cf / oidc 環境ではリファレンスルームが同一ドメイン配下で提供されるため、
  // ドメイン付き URL ではなく相対パスで遷移する。
  // NOTE: この分岐は CloudFront 並行稼働中の暫定対応で、最終的には相対パス固定になり削除する。
  //       捨てる前提のため、万一の例外は握り潰して従来ロジックにフォールバックする。
  try {
    const hostname = window.location.hostname;
    if (hostname.startsWith('otameshi.') || hostname.startsWith('cf.') || hostname.startsWith('oidc.')) {
      return '/reference-room/handouts';
    }
  } catch {
    // 何もしない（従来ロジックへフォールバック）
  }

  if (window.CODMON_MANIFEST.features?.navigateReferenceRoomCf) {
    return '/reference-room/handouts';
  }

  // それ以外の環境では従来通り、ドメイン付き URL で遷移する。
  const newReferenceRoomUrl = `${window.CODMON_MANIFEST.urls.REFERENCE_ROOM_URL}/handouts`;
  return newReferenceRoomUrl;
}
